module.exports = __webpack_public_path__ + "static/media/Fantasy_1.745cf2e5.jpg";